module.exports = __webpack_public_path__ + "static/media/ice.0371d2cd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/ice.gif
// module id = 53
// module chunks = 0